import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchCategory } from '../services/menuService';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [containerRef, isIntersecting] = useIntersectionObserver();
  
  // Check if device is mobile for reduced animation delays
  const isMobile = window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const animationDelay = isMobile ? 0.05 : 0.1;

  useEffect(() => {
    const loadCategory = async () => {
      try {
        setLoading(true);
        const data = await fetchCategory(categoryId);
        setCategory(data);
        setError(null);
      } catch (err) {
        console.error('Failed to load category:', err);
        setError('Failed to load category. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    loadCategory();
  }, [categoryId]);

  if (loading) {
    return (
      <div className={`category-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
        <Link to="/" className="back-button">← Back to Menu</Link>
        <div className="loading-message">Loading category...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`category-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
        <Link to="/" className="back-button">← Back to Menu</Link>
        <div className="error-message">{error}</div>
      </div>
    );
  }

  if (!category) {
    return (
      <div className={`category-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
        <Link to="/" className="back-button">← Back to Menu</Link>
        <div className="category-header">
          <h1 className="category-name">Category Not Found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className={`category-page ${isIntersecting ? 'fade-in-active' : ''}`} ref={containerRef}>
      <Link to="/" className="back-button">← Back to Menu</Link>
      
      <div className="category-header">
        <h1 className="category-name">{category.name}</h1>
        <div className="category-subtitle">{category.description}</div>
      </div>

      <div className="menu-items">
        {category.items.map((item, index) => (
          <div 
            key={index} 
            className={`menu-item ${isIntersecting ? 'fade-in-up-active' : ''}`}
            style={{ animationDelay: `${(index + 1) * animationDelay}s` }}
          >
            <div className="item-content">
              <div className="item-info">
                <div className="item-name">{item.name}</div>
                {item.description && (
                  <div className="item-description">{item.description}</div>
                )}
              </div>
              <div className="item-price">{item.price}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryPage;

